import url from '../url'
import headers from '../headers'
import moment from 'moment'

export default {
	add (context, user_uid, watch_id, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/watches/${watch_id}/pills/`,
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, watch_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/watches/${watch_id}/pills/${model.id}/`,
			model,
			headers.bearer()
		)
	},
	getAll (context, user_uid, watch_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/pills/`,
			headers.bearer()
		)
	},
	getActive (context, user_uid, watch_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/pills/active/`,
			headers.bearer()
		)
	},
	getByDay (context, user_uid, watch_id, day) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/pills/day/${day}/`,
			headers.bearer()
		)
	},
	getByInterval (context, user_uid, watch_id, date_start, date_end) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/pills/interval/${date_start}/to/${date_end}/`,
			headers.bearer()
		)
	},
	getById (context, user_uid, watch_id, id) {
		return context.$http.get(
			`${url}/users/${user_uid}/watches/${watch_id}/pills/${id}/`,
			headers.bearer()
		)
	},
	delete (context, user_uid, watch_id, id) {
		return context.$http.delete(
			`${url}/users/${user_uid}/watches/${watch_id}/pills/${id}/`,
			headers.bearer()
		)
	},
	pillstaken: {
		add (context, user_uid, watch_id, pill_id, model) {
			return context.$http.post(
				`${url}/users/${user_uid}/watches/${watch_id}/pills/${pill_id}/taken/`,
				model,
				headers.bearer()
			)
		},
		edit (context, user_uid, watch_id, model) {
			return context.$http.put(
				`${url}/users/${user_uid}/watches/${watch_id}/pills/taken/${model.id}/`,
				model,
				headers.bearer()
			)
		},
		getAll (context, user_uid, watch_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/pills/taken/`,
				headers.bearer()
			)
		},
		getByInterval (context, user_uid, watch_id, date_start, date_end) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/pills/taken/interval/${date_start}/to/${date_end}/`,
				headers.bearer()
			)
		},
		getByDay (context, user_uid, watch_id, day) {
			return context.$http.get(
				`${url}/users/${user_uid}/watches/${watch_id}/pills/taken/day/${day}/`,
				headers.bearer()
			)
		},
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/pillbox2.js